import React from 'react';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';

import Alert from 'reactstrap/lib/Alert';
import { Link } from 'react-router-dom';
import Row from 'reactstrap/lib/Row';
import Col from 'reactstrap/lib/Col';

import { receiveProducts } from '@ttstr/actions';
import { Container, LoadingSpinner, Masonry, useIntl, Video } from '@ttstr/components';
import { AppState } from '@ttstr/reducers';
import { useActions, useShallowEqualSelector } from '@ttstr/utils';

const OsterSaleListing: React.FC = () => {
  const { t } = useTranslation();
  const { loading, products } = useShallowEqualSelector(mapStateToProps);
  const { receiveProducts } = useActions(mapDispatchToProps);
  const { language } = useIntl();

  React.useEffect(() => {
    receiveProducts();
  }, [language]);

  return (
    <article>
      <Helmet>
        <title>{t(`PRODUCTS.TITLE`)}</title>
        <body className="product-listing-page" />
      </Helmet>
      <Container className="video-player-container d-flex justify-content-center p-0 mx-0 w-100">
        <Video
          preload="auto"
          muted // autoPlay only works in Safari when muted
          autoPlay
          disablePictureInPicture
          loop={true}
          playsInline
          nativeControls={false}
          controls
          controlColor="light"
          controlOutline
          controlsList="nodownload nofullscreen noremoteplayback"
          poster={require('./assets/images/FB_MailHeader_Ostersale_30032026_B.jpg')}
          containerClassName="d-none d-md-block sticky-top fold-behind"
          className="fullsize-video"
        >
          <source
            src="https://cdn.tickettoaster.de/fettesbrot/2_Webside_Header_Osterspecial_WebOptimized_Small.mp4"
            type="video/mp4"
          />
        </Video>

        <Video
          preload="auto"
          muted // autoPlay only works in Safari when muted
          autoPlay
          disablePictureInPicture
          loop={true}
          playsInline
          nativeControls={false}
          controls
          controlColor="light"
          controlOutline
          controlsList="nodownload nofullscreen noremoteplayback"
          poster={require('./assets/images/FB_MailHeader_Ostersale_30032026_B.jpg')}
          containerClassName="d-block d-md-none sticky-top fold-behind"
          className="fullsize-video"
        >
          <source
            src="https://cdn.tickettoaster.de/fettesbrot/2_Webside_Header_Osterspecial_WebOptimized_Small.mp4"
            type="video/mp4"
          />
        </Video>
      </Container>

      <Container fluid className="hero d-flex justify-content-center align-items-center flex-column px-5">
        <img
          src={require('./assets/images/fb_ostern.png')}
          className="img-fluid w-100 my-5 oster-header-image"
          alt="Oster Sale Header"
        />
      </Container>

      <Container className="listing-filter-buttons-container">
        <Row className="mb-4 d-flex align-items-center justify-content-center listing-buttons-container">
          <Col sm="12" md="12" lg="12" className="mt-2">
            <Link
              to="/ostersale"
              className="btn btn-primary btn-tickets h-100 mr-2 mb-2"
              onClick={() => {
                const element = document.getElementById('listing');
                if (!element) return;
                window.scroll({
                  top: element.offsetTop - 100,
                  behavior: 'smooth',
                });
              }}
            >
              Alles
            </Link>
            <Link
              to="/ostersale?categoryId=3984"
              className="btn btn-primary btn-tickets h-100  mr-2 mb-2"
              onClick={() => {
                const element = document.getElementById('listing');
                if (!element) return;
                window.scroll({
                  top: element.offsetTop - 100,
                  behavior: 'smooth',
                });
              }}
            >
              Tonträger
            </Link>
            <Link
              to="/ostersale?categoryId=3985"
              className="btn btn-primary btn-tickets h-100  mr-2 mb-2"
              onClick={() => {
                const element = document.getElementById('listing');
                if (!element) return;
                window.scroll({
                  top: element.offsetTop - 100,
                  behavior: 'smooth',
                });
              }}
            >
              Textilien
            </Link>
            <Link
              to="/ostersale?categoryId=3993"
              className="btn btn-primary btn-tickets h-100  mr-2 mb-2"
              onClick={() => {
                const element = document.getElementById('listing');
                if (!element) return;
                window.scroll({
                  top: element.offsetTop - 100,
                  behavior: 'smooth',
                });
              }}
            >
              Zeug
            </Link>
            <Link
              to="/ostersale?categoryId=4112"
              className="btn btn-primary btn-tickets h-100  mr-2 mb-2"
              onClick={() => {
                const element = document.getElementById('listing');
                if (!element) return;
                window.scroll({
                  top: element.offsetTop - 100,
                  behavior: 'smooth',
                });
              }}
            >
              Kids
            </Link>
          </Col>
        </Row>
      </Container>

      <Container className="list-page">
        {loading ? ( // if loading
          <LoadingSpinner label={t(`LOADING.PRODUCTS`)} />
        ) : products.length === 0 ? ( // if no products
          <Alert color="info">{t(`MASONRY.NO_ITEMS`)}</Alert>
        ) : (
          // else show products
          <Masonry
            id="product-listing"
            products={products.filter((p) => !p.tag_ids.includes(9916))}
            filters="off"
            columnClassName="col-sm-6 col-lg-4"
            showSubtitle
            dontUpdateQueryStrings
            showFormerPrice
            // itemClassName="random-rotation-object"
            // itemImageClassName="scribble-hover-overlay-object"
          />
        )}
      </Container>
    </article>
  );
};

const mapStateToProps = (state: AppState) => {
  const { products, loading } = state.Products;
  return {
    products,
    loading,
  };
};

const mapDispatchToProps = {
  receiveProducts,
};

export default React.memo(OsterSaleListing);
